<template>
  <div>
    <div class="head">
      <el-form :inline="true" :model="selectForm" ref="orderReceipt" class="demo-form-inline" size="mini">
        <el-form-item>
          <el-date-picker
            v-model="dateTimes"
            type="monthrange"
            align="right"
            unlink-panels
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始月"
            end-placeholder="结束月"
            :picker-options="pickerOptions"
            @change="changeDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select multiple collapse-tags v-model="selectForm.categoryId" clearable style="width: 150px;margin-right: 5px"  placeholder="请选择栏目(默认全部)">
            <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select  v-model="selectForm.supplyId" clearable style="width: 150px;margin-right: 5px"  placeholder="请选择经理">
            <el-option v-for="item in appInfo.supplyList" :key="item.supplyId" :label="item.name" :value="item.supplyId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
      </el-form>
    </div>
    <div class="echarts" :style="{height: windowHeight + 'px'} ">
      <chart theme="macarons" :options="lineOptions" ref="echarLine" :auto-resize="true" />
      <chart theme="macarons" :options="radarOptions" ref="echarRadar" :auto-resize="true" />
      <chart theme="macarons" :options="supplyOptions" ref="echarSupply" :auto-resize="true" />
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import theme from '../../../ECharts/macarons.json'
import 'echarts/theme/dark'
import chinaMap from '../../../ECharts/china.json'
import {financeByYear, areaByYear, areaBySupply} from '../../../api/ordersStatistics'
import { getAppInfo } from '../../../api/app'

ECharts.registerTheme('macarons', theme)
ECharts.registerMap('china', chinaMap)
export default {
  components: {
    chart: ECharts
  },
  data: function () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      windowHeight: '',
      selectForm: {
        appId: '',
        categoryId: [],
        dateType: '2',
        dateTime: '',
        endTime: '',
        startTime: ''
      },
      dateTimes: [],
      appInfo: {},
      lineOptions: {
        title: {
          text: '年度销售额对比'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        toolbox: {
          show: true,
          feature: {
            magicType: {type: ['line', 'bar']},
            saveAsImage: {show: true}
          },
          right: '100'
        },
        calculable: true,
        grid: {
          top: 80,
          bottom: 50,
          left: 80,
          right: 50,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'line',
              lineStyle: {
                type: 'dashed'
              },
              label: {
                backgroundColor: '#6a7985'
              }
            }
          }
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0
          },
          boundaryGap: false,
          splitLine: {show: false},
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: [
          {
            type: 'value',
            name: '销售额（元）'
          }
        ],
        series: []
      },
      pieDataYeaSalesr: '',
      radarOptions: {
        title: {
          text: '发货地点分布'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
          // formatter: function (params) {
          //   console.log(params)
          //   let y = params[0]['axisValueLabel']
          //   let sum = 0
          //   let str = ''
          //   params.forEach((i) => {
          //     if (i['data'] === 0) {
          //       str += '<br />' + i['seriesName'] + '：' + i['data']
          //     } else {
          //       str += '<br />' + i['seriesName'] + '：' + i['data'] + ' （' + (i['data'] / sum * 100).toFixed(2) + '%）'
          //     }
          //   })
          //   return y + str
          // }
        },
        legend: {
          data: []
        },
        toolbox: {
          show: true,
          feature: {
            magicType: {type: ['line', 'bar', 'stack', 'tiled']},
            saveAsImage: {show: true}
          },
          right: '100'
        },
        grid: {
          left: '50%',
          right: 80,
          bottom: 40,
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: []
        },
        visualMap: {
          showLabel: true,
          min: 0,
          max: 10000,
          calculable: true,
          bottom: 30,
          left: 'left',
          text: ['高', '低'],
          colorLightness: [0.2, 100],
          color: ['#c05050', '#e5cf0d', '#5ab1ef'],
          dimension: 0,
          seriesIndex: 0
        },
        // radar: {
        //   // shape: 'circle',
        //   name: {
        //     textStyle: {
        //       color: '#fff',
        //       backgroundColor: '#999',
        //       borderRadius: 3,
        //       padding: [3, 5]
        //     }
        //   },
        //   center: ['23%', '50%'],
        //   indicator: []
        // },
        series: []
      },
      supplyOptions: {
        title: {
          text: '经理发货地点分布'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params, ticket) {
            let y = params[0]['axisValueLabel']
            let sum = 0
            let str = ''
            params.forEach((i) => {
              sum += i['data']
            })
            params.forEach((i) => {
              if (i['data'] === 0) {
                str += '<br />' + i['seriesName'] + '：' + i['data']
              } else {
                str += '<br />' + i['seriesName'] + '：' + i['data'] + ' （' + (i['data'] / sum * 100).toFixed(2) + '%）'
              }
            })
            return y + str
          }
        },
        legend: {
          type: 'scroll',
          top: 20,
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: []
      },
      randarPi: []
    }
  },
  created () {
    this.$nextTick(() => {
      this.windowHeight = document.documentElement.offsetHeight - 270
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.selectForm.appId = to.params.id
      getAppInfo(to.params.id).then((response) => {
        vm.appInfo = response.data.data
      })
    })
  },
  methods: {
    search () {
      this.initSupply()
      this.intiLint()
      this.initArea()
    },
    changeDate (item) {
      if (item !== null) {
        this.selectForm.startTime = item[0]
        this.selectForm.endTime = item[1]
        this.selectForm.dateTime = item[0]
      } else {
        this.selectForm.startTime = null
        this.selectForm.dateTime = null
        this.selectForm.endTime = null
      }
    },
    intiLint () {
      let _this = this
      _this.lineOptions.legend.data = []
      _this.lineOptions.series = []
      financeByYear(this.selectForm).then((response) => {
        _this.financeYear = response.data.data
        let piDatas = []
        for (let i in _this.financeYear) {
          _this.lineOptions.legend.data.push(i.substring(0, 4))
          _this.pieDataYeaSalesr = _this.wei.createYear(_this.financeYear[i], i.substring(0, 4))
          piDatas.push({
            name: i.substring(0, 4),
            value: _this.pieDataYeaSalesr.sum
          })
          _this.lineOptions.series.push({
            name: i.substring(0, 4),
            type: 'line',
            areaStyle: {
              opacity: 0.2
            },
            markPoint: {
              data: [
                {type: 'max', name: '最大值'}
              ]
            },
            label: {
              normal: {
                show: true
              }
            },
            data: _this.pieDataYeaSalesr.daysOfMonth.map(function (itme) {
              return itme.moneySum
            })
          })
        }
        _this.lineOptions.series.push({
          name: '销售占比',
          type: 'pie',
          center: ['90%', '25%'],
          radius: ['10%', '20%'],
          roseType: 'angle',
          data: piDatas,
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}元 ({d}%)'
          },
          // tooltip: {
          //   trigger: 'item',
          //   formatter: '{b} : {c} ({d}%)'
          // },
          label: {
            normal: {
              borderRadius: 5,
              padding: 5,
              textBorderColor: '#fff',
              textBorderWidth: 5
            }
          },
          itemStyle: {
            opacity: 0.1,
            normal: {
              shadowBlur: 100,
              shadowColor: 'rgba(0, 0, 0, 0.3)'
            }
          }
        })
      })
      this.$refs.echarLine.mergeOptions(this.lineOptions)
    },
    initArea () {
      let _this = this
      areaByYear(this.selectForm).then((res) => {
        if (res.data.data == null) {
          return
        }
        _this.radarOptions.legend.data = []
        _this.radarOptions.series = []
        _this.randarPi = []
        // _this.radarOptions.radar.indicator = []
        // _this.radarOptions.series[0] = {
        //   name: '发货地点分布',
        //   type: 'radar',
        //   itemStyle: {normal: {areaStyle: {type: 'default', opacity: 0.2}}},
        //   // areaStyle: {normal: {}},
        //   data: []
        // }
        let radarData = res.data.data
        _this.radarOptions.visualMap.max = radarData.max
        _this.radarOptions.legend.data = radarData.year.map(function (item) {
          return item
        })
        // _this.radarOptions.radar.indicator = radarData.areaMax.map(function (item) {
        //   return {
        //     name: item.province
        //   }
        // })
        _this.radarOptions.yAxis.data = radarData.areaMax.map(function (item) {
          return item.province
        })
        _this.radarOptions.series.push({
          type: 'map',
          mapType: 'china',
          left: '10px',
          roam: false,
          tooltip: {
            show: true,
            trigger: 'item',
            axisPointer: {
              type: 'shadow'
            },
            formatter: function (params) {
              let str = `${params.name}`
              let a = ''
              for (let i in radarData.data) {
                if (radarData.data[i][params.dataIndex]) {
                  let sum = 0
                  radarData.data[i].forEach(i => {
                    sum += i.count
                  })
                  a += ('<br/>' + i + ': ' + radarData.data[i][params.dataIndex].count + ' （' + (radarData.data[i][params.dataIndex].count / sum * 100).toFixed(2) + '%）')
                }
              }
              return str + a
            }
          },
          data: radarData.data[radarData.year[0]].map(function (itme) {
            return {
              name: itme.province
            }
          })
        })
        for (let i in radarData.data) {
          _this.radarOptions.series.push({
            name: i,
            type: 'bar',
            stack: '总量',
            label: {
              normal: {
                show: true,
                position: 'insideRight'
              }
            },
            tooltip: {
              show: true,
              formatter: function (params) {
                console.log(params)
              }
            },
            data: radarData.data[i].map(function (itme) {
              return itme.count
            })
          })
          let sum = 0
          radarData.data[i].forEach(function (itme) {
            sum += (itme.count * 1)
          })
          _this.randarPi.push({
            name: i,
            value: sum
          })
          _this.radarOptions.series.push({
            name: i,
            type: 'map',
            mapType: 'china',
            left: '5%',
            label: {
              normal: {
                'textStyle': {
                  'color': '#d87a80'
                }
              }
            },
            'itemStyle': {
              'normal': {
                'borderColor': '#2196f3'
              },
              'emphasis': {
                areaColor: '#fff464'
              }
            },
            tooltip: {
              show: true,
              trigger: 'item',
              axisPointer: {
                type: 'shadow'
              }
            },
            data: radarData.areaNot[i].map(function (itme) {
              return {
                name: itme.province,
                value: itme.count
              }
            })
          })
          _this.radarOptions.series[0].data.push({
            name: i,
            value: radarData.data[i].map(function (itme) {
              return itme.count
            }),
            tooltip: {
              formatter: '{b}'
            }
          })
        }
        _this.radarOptions.series.push({
          name: '发货占比',
          type: 'pie',
          center: ['90%', '25%'],
          radius: ['10%', '20%'],
          roseType: 'angle',
          data: _this.randarPi,
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          label: {
            normal: {
              borderRadius: 5,
              padding: 5,
              textBorderColor: '#fff',
              textBorderWidth: 5
            }
          },
          itemStyle: {
            opacity: 0.1,
            normal: {
              shadowBlur: 100,
              shadowColor: 'rgba(0, 0, 0, 0.3)'
            }
          }
        })
      })
      this.$refs.echarRadar.mergeOptions(this.radarOptions)
    },
    initSupply () {
      let _this = this
      areaBySupply(this.selectForm).then((res) => {
        // _this.$refs.echarSupply.clear()
        if (res.data.data == null) {
          return
        }
        _this.supplyOptions.legend.data = []
        let supplyPi = []
        _this.supplyOptions.series = []
        let supplyData = res.data.data
        _this.supplyOptions.yAxis.data = supplyData.area.map(function (item) {
          return item.province
        })
        for (let i in supplyData.data) {
          _this.supplyOptions.legend.data.push(i)
          _this.supplyOptions.series.push({
            name: i,
            type: 'bar',
            stack: '总量',
            data: supplyData.data[i].map(function (itme) {
              return itme.count
            })
          })
          let sum = 0
          supplyData.data[i].forEach(function (itme) {
            sum += (itme.count * 1)
          })
          supplyPi.push({
            name: i,
            value: sum
          })
        }
        _this.supplyOptions.series.push({
          name: '发货占比',
          type: 'pie',
          center: ['80%', '30%'],
          radius: ['10%', '20%'],
          roseType: 'angle',
          data: supplyPi,
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          label: {
            normal: {
              borderRadius: 5,
              padding: 5,
              textBorderColor: '#fff',
              textBorderWidth: 5
            }
          },
          itemStyle: {
            opacity: 0.1,
            normal: {
              shadowBlur: 100,
              shadowColor: 'rgba(0, 0, 0, 0.3)'
            }
          }
        })
        this.$refs.echarSupply.mergeOptions(this.initSupply)
      })
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .grid-content
    display: flex
    align-items: center
    height: 100px
  .grid-cont-right
    flex: 1
    text-align: center
    font-size: 12px
    color: #999
  .grid-num
    font-size: 30px
    font-weight: bold
  .ldms-font
    font-size: 50px
    width: 100px
    height: 100px
    text-align: center
    line-height: 100px
    color: #fff
  .grid-con-1 .ldms-font
    background: rgb(45, 140, 240)
  .grid-con-1 .grid-num
    color: rgb(45, 140, 240)
  .grid-con-2 .ldms-font
    background: rgb(100, 213, 114)
  .grid-con-2 .grid-num
    color: #65d472
  .grid-con-3 .ldms-font
    background: rgb(242, 94, 67)
  .grid-con-3 .grid-num
    color: rgb(242, 94, 67)
  .head
    width 100%
    padding 10px
    background: #fff
    border-radius: 8px 8px 0 0
    margin-top: 12px
    padding-left: 30px
    padding-right: 30px
  .echarts
    width: 100%
    height 100%
    margin: auto
    background: #fff
    overflow auto
    &::-webkit-scrollbar
      width: 10px
      height: 1px
    &::-webkit-scrollbar-thumb
      background-color: #F90
      background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent)
    &::-webkit-scrollbar-track
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2)
      background: #EDEDED
</style>
